import Mutations from '../../odata/mutations';

export default { ...new Mutations('productImage'), ...new Mutations('productImages') };
